import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { SELECT_MOBILE_USER_DETAILS } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";

/*
 * Provider id and org position key both live on the same mobile-user row, so
 * one call covers what the bulk pay-request payload needs.
 */
export const getMobileUserDetails = async (cookiesData, dispatch) => {
  if (!cookiesData) return null;

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
    };

    const response = await POSTAPI(false, SELECT_MOBILE_USER_DETAILS, null, apiHeaders, requestBody, dispatch);
    const row = response?.data?.row_result?.[0];

    if (response?.data?.out_parameters?.out_ret_code === API_CONSTANTS.SUCCESS_CODE && row) {
      return {
        providerId: row.provider_mstr_key ?? null,
        orgPositionKey: row.org_position_key ?? 0,
      };
    }
    return null;
  } catch (error) {
    console.error("Error fetching mobile user details:", error);
    return null;
  }
};
